// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1MYW9","overflowing":"ReadFullNote_overflowing__1Thjq"};